/* ============================================================
   PSM combined-listing unified table (NZ).
   For products that are BOTH a combined listing (Model option)
   AND have a variant axis (e.g. LED Colour), this merges the
   Model selector and the variant picker into ONE grouped table:
   each model is a group header, its variants are the rows.
   Per-model variant data (sku / colour / price / real inventory)
   comes from /products/<handle>?section_id=psm-model-variants.

   NZ B2B gate: the section emits real prices only for customer.b2b?.
   For guests (data.b2b === false) the price cell renders the same
   locked placeholder as psm-model-row.liquid / price.liquid.
   ============================================================ */
(function () {
  "use strict";

  var modelBox = document.querySelector(".model-box");
  if (!modelBox) return;
  var list = modelBox.querySelector(".model-list");
  if (!list) return;
  if (modelBox.querySelector(".ml-unified")) return; // already transformed

  // only transform when there's a second variant axis to fold in
  var subSelectors = [].slice.call(document.querySelectorAll(".option-selector"))
    .filter(function (s) { return !s.classList.contains("model-box"); });
  if (!subSelectors.length) return;

  var models = [].slice.call(list.querySelectorAll(".opt-btn")).map(function (r) {
    return { url: (r.dataset.productUrl || "").split("?")[0], name: r.value };
  }).filter(function (m) { return m.url; });
  if (!models.length) return;

  var coll = location.pathname.match(/^(\/collections\/[^/]+)\/products\//);
  function withColl(url) {
    if (coll && url.indexOf("/collections/") === -1) return url.replace("/products/", coll[1] + "/products/");
    return url;
  }
  function handleOf(url) { return (url.split("/products/")[1] || "").split("?")[0].split("/")[0]; }
  var curHandle = handleOf(location.pathname);
  var curVariant = (document.querySelector('.product-info input[name="id"]') || {}).value ||
    new URLSearchParams(location.search).get("variant") || "";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  var LOCKED_PRICE = '<span class="ml-price ml-price--locked" data-locked aria-hidden="true">$&bull;&bull;&bull;.&bull;&bull;</span>';

  Promise.all(models.map(function (m) {
    return fetch(m.url + "?section_id=psm-model-variants")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, "text/html").querySelector(".shopify-section");
        if (!el) return null;
        return { model: m, data: JSON.parse(el.textContent) };
      })
      .catch(function () { return null; });
  })).then(function (results) {
    results = results.filter(Boolean);
    if (!results.length) return;
    // If any sibling fetch failed, leave the native selectors intact rather than
    // showing a partial table that omits unreachable models.
    if (results.length < models.length) return;
    var total = results.reduce(function (n, r) { return n + r.data.variants.length; }, 0);
    if (total <= results.length) return; // every model is a single SKU — leave as-is

    var html = "";
    results.forEach(function (r) {
      var url = withColl(r.data.url);
      var rHandle = handleOf(r.data.url);
      html += '<div class="ml-group" aria-hidden="true">' + esc(r.model.name) + "</div>";
      r.data.variants.forEach(function (v) {
        var cls = "", txt = "In stock";
        if (!v.available) { cls = "bo"; txt = "Sold out"; }
        else if (v.tracked && v.qty <= 0) { cls = "bo"; txt = "Backorder"; }
        var current = rHandle === curHandle && String(v.id) === String(curVariant);
        var priceCell = r.data.b2b
          ? '<span class="ml-price">' + esc(v.priceCur) + "</span>"
          : LOCKED_PRICE;
        html += '<a class="ml-row ml-row--variant' + (current ? " ml-row--current" : "") +
          '" href="' + esc(url + "?variant=" + v.id) + '">' +
          '<span class="ml-sku">' + esc(v.sku) + "</span>" +
          '<span class="ml-ver">' + esc(v.colour) + "</span>" +
          '<span class="ml-stock ' + cls + '"><span class="dot"></span><span class="ml-stock-txt">' + txt + "</span></span>" +
          priceCell +
          "</a>";
      });
    });
    // Don't overwrite the original .model-list — the theme's own scripts
    // (variant-picker.js, model-option.js) hold live references to the model
    // radios inside it and throw if they vanish. Hide it instead and insert
    // the unified table as a sibling.
    var table = document.createElement("div");
    table.className = "model-list ml-unified";
    table.innerHTML = html;
    list.style.display = "none";
    list.insertAdjacentElement("afterend", table);

    var h3 = modelBox.querySelector(".model-head h3");
    if (h3) {
      var icon = h3.querySelector("svg");
      h3.textContent = "";
      if (icon) h3.appendChild(icon);
      h3.appendChild(document.createTextNode(" " + total + " models available"));
    }

    subSelectors.forEach(function (s) { s.style.display = "none"; });
  });
})();
